import { ReactNode, useEffect, useRef, useState } from 'react';
import { ReactComponent as PlusIcon } from '../../assets/plus.svg';
import styles from './InlineReveal.module.scss';

type InlineRevealProps = {
  label: string;
  icon?: ReactNode;
  children: ReactNode;
  isOpen?: boolean;
};

export function InlineReveal({ label, icon, children, isOpen=false }: InlineRevealProps) {
  const [open, setOpen] = useState(isOpen);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;

    const el = containerRef.current?.querySelector<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >("input, textarea, select, button, [tabindex]:not([tabindex='-1'])");

    el?.focus();
  }, [open]);

  return (
    <div className={styles.inlineReveal}>
      {!open && (
        <span
          className={styles.inlineRevealTrigger}
          onClick={() => setOpen(true)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setOpen(true);
            }
          }}
          role='button'
          tabIndex={0}
        >
          {icon ?? <PlusIcon />}
          {label}
        </span>
      )}

      <div
        ref={containerRef}
        className={`${styles.inlineRevealContent} ${open ? styles.open : ''}`}
      >
        {children}
      </div>
    </div>
  );
}
